/**
 * Horizontal scroll nav — mouse drag-to-scroll na desktopu.
 *
 * Na mobile native touch swipe deluje preko CSS (overflow-x: auto).
 * Tukaj dodamo še mouse drag (click+vleci) za desktop uporabnike.
 *
 * Klik na link normalno sledi href-u; samo če user dejansko premakne kazalec
 * (čez prag), interpretiramo gesto kot drag in suppress-amo končni click.
 */

const DRAG_THRESHOLD = 5; // px

export default {
	init() {
		const navs = document.querySelectorAll('.horizontal-scroll-nav');
		if (!navs.length) return;
		navs.forEach((el) => bindDrag(el));
	}
};

function bindDrag(el) {
	let isDown = false;
	let didMove = false;
	let startX = 0;
	let startScroll = 0;

	function onDown(e) {
		// Samo levi gumb miške.
		if (e.button !== undefined && e.button !== 0) return;
		isDown = true;
		didMove = false;
		startX = e.pageX;
		startScroll = el.scrollLeft;
	}

	function onMove(e) {
		if (!isDown) return;
		const dx = e.pageX - startX;
		if (!didMove && Math.abs(dx) < DRAG_THRESHOLD) return;
		didMove = true;
		el.classList.add('is-dragging');
		// preventDefault preprečuje text selection in native drag-image.
		e.preventDefault();
		el.scrollLeft = startScroll - dx;
	}

	function onUp() {
		if (!isDown) return;
		isDown = false;
		// Damo browserju eno tick rezerve, da odpošlje click event (in ga
		// onClickCapture prestreže), potem počistimo didMove + razred.
		const wasMove = didMove;
		setTimeout(() => {
			el.classList.remove('is-dragging');
			didMove = false;
		}, 0);
		// Suppress takojšen click samo če je dejansko bil drag.
		if (!wasMove) {
			el.classList.remove('is-dragging');
		}
	}

	function onClickCapture(e) {
		// V capture phase prestrežemo klik, če smo pravkar dragali.
		if (didMove) {
			e.preventDefault();
			e.stopPropagation();
		}
	}

	// Native HTML5 drag (drag image / drag-to-bookmark) bi prekinil naš drag —
	// blokiramo, da je experience tekoč.
	function onDragStart(e) {
		e.preventDefault();
	}

	// KLJUČNO: mousemove + mouseup vežemo na DOCUMENT (ne na el), da prejmemo
	// dogodke tudi ko mouse zapusti container ali se hitro premakne čez child link.
	el.addEventListener('mousedown', onDown);
	document.addEventListener('mousemove', onMove);
	document.addEventListener('mouseup', onUp);
	el.addEventListener('click', onClickCapture, true);
	el.addEventListener('dragstart', onDragStart);

	el.classList.add('is-grabbable');
}
